/**
 * DistanceBtwTwoStrings : calculating distance between two string
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 */
const DistanceBtwTwoStrings = (function() {
    function _min(d0, d1, d2, bx, ay) {
        return d0 < d1 || d2 < d1
            ? d0 > d2 ? d2 + 1 : d0 + 1
            : bx === ay ? d1 : d1 + 1;
    }

    /**
     * compare : comparing two string
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     *  * @param stringA string
     *  * @param stringB string
     */
    const compare = (stringA, stringB) => {
        let stringALength = stringA.length;
        let stringBLength = stringB.length;
        if (stringA === stringB) return 0;
        if (stringA.length > stringB.length) {
            const temp = stringA;
            stringA = stringB;
            stringB = temp;
        }

        while (stringALength > 0 && (stringA.charCodeAt(stringALength - 1) === stringB.charCodeAt(stringBLength - 1))) {
            stringALength--;
            stringBLength--;
        }
        let offset = 0;
        while (offset < stringALength && (stringA.charCodeAt(offset) === stringB.charCodeAt(offset))) {
            offset++;
        }

        stringALength -= offset;
        stringBLength -= offset;

        if (stringALength === 0 || stringBLength < 3) {
            return stringBLength;
        }

        let x = 0, y, d0, d1, d2, d3, dd, dy, ay, bx0, bx1, bx2, bx3;
        const vector = [];

        for (y = 0; y < stringALength; y++) {
            vector.push(y + 1);
            vector.push(stringA.charCodeAt(offset + y));
        }
        const len = vector.length - 1;

        for (; x < stringBLength - 3;) {
            bx0 = stringB.charCodeAt(offset + (d0 = x));
            bx1 = stringB.charCodeAt(offset + (d1 = x + 1));
            bx2 = stringB.charCodeAt(offset + (d2 = x + 2));
            bx3 = stringB.charCodeAt(offset + (d3 = x + 3));
            dd = (x += 4);
            for (y = 0; y < len; y += 2) {
                dy = vector[y];
                ay = vector[y + 1];
                d0 = _min(dy, d0, d1, bx0, ay);
                d1 = _min(d0, d1, d2, bx1, ay);
                d2 = _min(d1, d2, d3, bx2, ay);
                dd = _min(d2, d3, dd, bx3, ay);
                vector[y] = dd;
                d3 = d2;
                d2 = d1;
                d1 = d0;
                d0 = dy;
            }
        }

        for (; x < stringBLength;) {
            bx0 = stringB.charCodeAt(offset + (d0 = x));
            dd = ++x;
            for (y = 0; y < len; y += 2) {
                dy = vector[y];
                vector[y] = dd = _min(dy, d0, dd, bx0, vector[y + 1]);
                d0 = dy;
            }
        }
        return dd;
    };
    return {
        compare
    };
})();
